var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitch = function SvgTwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 72"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#5A3E85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M42.776 48.366h-7.034l-4.69 4.594h-4.694v-4.594H17.76V23.882l2.346-6.122H52.16v21.428zm6.258-10.712V20.818H23.23V43.01h7.04v4.588l4.689-4.588h8.6l5.474-5.357zm-17.202-1.528v-9.182h3.128v9.182zm8.6 0v-9.182h3.127v9.182z"
  }))));
};
export default SvgTwitch;